<template>
    <div v-if="menuBanners.length" class="brands" @click="$emit('hideMenu')">
        <!--      <div class="brands__title mb-0 fwb fs-14">{{ dictionary.brands }}</div>-->
        <!-- Link -->
        <template v-if="isPwa">
            <a
                v-for="(item, index) in menuBanners"
                @click.prevent="$emit('redirectToUrl', $event)"
                :key="index"
                :href="item.url"
                class="brands__item"
                :id="`brands-item-${item.id}`"
                :title="item.title"
            >
                <img :src="item.image" :alt="item.title" loading="lazy" />
            </a>
        </template>
        <template v-else>
            <a
                v-for="(item, index) in menuBanners"
                :key="index"
                :href="item.url"
                class="brands__item"
                :id="`brands-item-${item.id}`"
                :title="item.title"
            >
                <img :src="item.image" :alt="item.title" loading="lazy" />
            </a>
        </template>
        <!-- ense Link -->
    </div>
</template>

<script>
export default {
    props: {
        isPwa: {
            type: Boolean,
            required: true,
        },
        menuBanners: {
            type: Array,
            required: true,
        },
        dictionary: {
            type: Object,
            required: true,
        },
        cols: {
            type: Number,
            default: 2,
        },
    },
}
</script>

<style lang="scss" scoped>
.brands {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    align-items: center;
    background: #f1f5f9;
    padding: 36px 16px;
    position: relative;
    justify-content: center;

    @media (min-width: 768px) {
        padding: 36px 72px;
        justify-content: space-evenly;
        border-radius: 0 0 16px 16px;
    }

    &__title {
        color: #064740;
        font-size: 18px;
        display: block;
        grid-column: span 2;
    }

    &.mobile-brands {
        position: relative;
        width: 100%;
        right: 0;
        padding: 20px;
    }

    h4 {
        display: block;
        grid-column: span 2;
    }

    &__item {
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        transition: all 0.5s;

        @media (max-width: 1200px) {
            //padding: 0.75em 2em;
        }

        img {
            transition: all 0.5s;
            height: auto;
            max-height: 48px;
        }
    }
}
</style>
